import { cdnBaseUrl, ssqutil } from 'util/ssqutil';

export const cdn_imag_url_base = `${cdnBaseUrl}/images/images`;
export const gconf = {
  error401: false,
  handleError401: null,
  error403: false,
  donehref: false,
  logModbus: true,
  logHex: false,
  logReqRes: false,
  useBestUserDay: true,
  //oldpage: false,
  //showPublic: true,
  /*
  true : 개발되는 버전을 공개.
  false : 개발되는 버전을 공개하지 않고, 현재(ASIS)버전으로 동작하도록.
   */
  // ssqrelease1st: false,
  //
  // // 표시 결정함수.
  // show(menu: 'service' | 'community' | 'profile-write' | 'public-wels') {
  //
  //   if (menu === 'community') {
  //     if (gconf.showPublic) {
  //       return true;
  //     }
  //     return false;
  //   } else if (menu === 'service') {
  //     if (gconf.showPublic && !gconf.ssqrelease1st) {
  //       return true;
  //     }
  //     return false;
  //   } else if (menu === 'public-wels') {
  //     if (gconf.showPublic) {
  //       return true;
  //     }
  //     return false;
  //   } else if (menu === 'profile-write') {
  //     if (gconf.showPublic) {
  //       return true;
  //     }
  //     return false;
  //   }
  //   return false;
  // },
};

export const openNewFeedback = true;

export const deleteToSaveInfo = true;

const prod = ssqutil.isProduction();
// export const openPtnrV2 = !prod;
export const openPtnrV2 = true; // 파트너 2.0 오픈 2026.07.09

//export const openSrchV3 = !prod;
export const openSrchV3 = true;

// 파트너 CRM v2 설정.
//export const openCrmV2 = !prod;
export const openCrmV2 = true;
// 파트너 CRM v1 활성화 테스트.
//export const openCrmV2 = false;

//export const openServo = !prod;
//export const openServo = true;
export const openServo = false;
